import React from 'react';
import PropTypes from 'prop-types';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import moment from 'moment';
import { valueByName } from './form_utils';

const DateTimePickerWrapper = React.forwardRef(({ value, onChange, label, helperText, error, ...props }, ref) => {
  return (
    <DateTimePicker
      label={label}
      value={value ? moment(value) : null}
      onChange={newValue => {
        onChange(newValue && moment.isMoment(newValue) ? newValue.toISOString() : null);
      }}
      enableAccessibleFieldDOMStructure={false}
      slots={{
        textField: TextField,
      }}
      slotProps={{
        textField: {
          fullWidth: true,
          margin: 'dense',
          variant: 'outlined',
          helperText: helperText,
          error: error,
        },
      }}
      ampm={false}
      disablePast
      format='D MMMM YYYY HH:mm'
      ref={ref}
      {...props}
    />
  );
});

export const ECDateTimeField = props => {
  const { name, label, form, defaultValue, initial, onChange, ...rest } = props;

  const dv = valueByName(initial, name) || defaultValue || moment().toISOString();

  return (
    <Controller
      control={form.control}
      name={name}
      defaultValue={moment(dv).isValid() ? moment(dv).toISOString() : null}
      render={({ field, fieldState }) => (
        <DateTimePickerWrapper
          {...field}
          label={label}
          helperText={fieldState.error?.message || (form.formState.errors[name] && form.formState.errors[name].message)}
          error={!!fieldState.error || !!form.formState.errors[name]}
          onChange={value => {
            field.onChange(value);
            onChange && onChange(value);
          }}
          {...rest}
        />
      )}
    />
  );
};

ECDateTimeField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  form: PropTypes.object,
  defaultValue: PropTypes.any,
  initial: PropTypes.object,
};
